import React, { useState } from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import LobbyItem from '../../components/common/LobbyItem';

import './lobby.scss';
import LobbyPopup from './LobbyPopup';
//
function Lobby() {
	const [show, setShow] = useState(false);
	const [choice, setChoice] = useState('');

	const handleClose = () => setShow(false);
	const handleShow = () => setShow(true);
	return (
		<Container className="d-flex justify-content-center vh-100">
			<Row className="align-items-center w-50">
				<Col>
					{/* <Link to="/1v1"> */}
					<LobbyItem
						title="join existing room"
						subTitle="find game automatically"
						onClick={() => {
							setChoice('random');
							handleShow();
						}}
					/>
					{/* </Link> */}
					{/* <Link to="/2v2"> */}
					{/* <LobbyItem
						title="Play 2 vs 2"
						subTitle="Play a two vs two game"
						onClick={() => {
							setChoice('random');
							handleShow();
						}}
					/> */}
					{/* </Link> */}
					{/* <Link to="/random"> */}
					<LobbyItem
						title="Join a room (with URL)"
						subTitle="Join your friends' room"
						onClick={() => {
							setChoice('url');
							handleShow();
						}}
					/>
					{/* </Link> */}
					{/* <Link to="/newTable"> */}
					<LobbyItem
						title="Create a new ROOM"
						subTitle="Create your own room, set your rules."
						plusIcon
						onClick={() => {
							setChoice('new');
							handleShow();
						}}
					/>
					{/* </Link> */}
				</Col>
			</Row>

			<LobbyPopup show={show} handleClose={handleClose} choice={choice} />
		</Container>
	);
}

export default Lobby;
